const UploadFileIcon = () => (
  <svg width={48} height={48} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 48 48`} fill="none">
    <path
      d="M16.9589 34.0206H12.9589C9.03891 34.0206 5.87891 30.8406 5.87891 26.9406C5.87891 24.9806 6.65891 23.2206 7.93891 21.9406C9.21891 20.6606 10.9989 19.8606 12.9589 19.8606H13.1589C13.1389 19.7006 13.1389 19.5406 13.1389 19.3806C13.1389 13.4406 17.9389 8.64062 23.8789 8.64062C29.8189 8.64062 34.6389 13.4406 34.6389 19.3806C34.6389 20.4806 34.4789 21.5406 34.1589 22.5606H36.4189C39.5789 22.5606 42.1389 25.1206 42.1389 28.2806C42.1389 29.8606 41.4989 31.3006 40.4589 32.3406C39.4189 33.3806 37.9989 34.0206 36.4189 34.0206H31.0789"
      stroke="#32465B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 39.3588V23.7188"
      stroke="#32465B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4395 27.06L23.9995 22.5L28.5595 27.06"
      stroke="#32465B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default UploadFileIcon;
